var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 184,
    viewBox: "0 0 182 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_7847)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.2469 110.454L0.521973 175.561V76.3608C0.521973 73.0405 1.84092 69.8563 4.18869 67.5085C6.53646 65.1608 9.72071 63.8418 13.041 63.8418H62.1219C63.1777 63.8419 64.2186 64.0909 65.1601 64.5685C66.1016 65.0461 66.9173 65.739 67.541 66.5908L82.496 87.0138L66.2469 110.454Z",
    fill: "#223ACF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.298 0.216797H69.77C65.904 0.216797 62.77 3.3508 62.77 7.2168V64.0208C62.77 67.8868 65.904 71.0208 69.77 71.0208H106.298C110.164 71.0208 113.298 67.8868 113.298 64.0208V7.2168C113.298 3.3508 110.164 0.216797 106.298 0.216797Z",
    fill: "white",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5273 12.2236H95.9763",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9893 15.0986H92.5163",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3062 24.1406H72.7902",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2964 24.1406H101.592",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2964 26.8408H101.592",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2964 29.541H88.9444",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5913 36.8369H73.0753",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5801 36.8369H101.876",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5801 39.5371H97.9201",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5801 42.2373H89.2281",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.875 49.2734H73.359",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8652 49.2734H102.161",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8652 51.9736H98.2052",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8652 54.6738H89.5132",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0329 18.2109H46.5059C41.5353 18.2109 37.5059 22.2404 37.5059 27.2109V80.0149C37.5059 84.9855 41.5353 89.0149 46.5059 89.0149H79.0329C84.0034 89.0149 88.0329 84.9855 88.0329 80.0149V27.2109C88.0329 22.2404 84.0034 18.2109 79.0329 18.2109Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2632 30.2178H70.7122",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7251 33.0928H67.2521",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.042 42.1348H47.526",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0322 42.1348H76.3282",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0322 44.835H76.3282",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.0322 47.5352H63.6802",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3271 54.8311H47.8111",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3159 54.8311H76.6119",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3159 57.5312H72.6559",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3159 60.2314H63.9639",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6108 67.2676H48.0948",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6011 67.2676H76.8971",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6011 69.9678H72.9411",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6011 72.668H64.2491",
    stroke: "#1D2736",
    strokeWidth: 0.435,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.396 182.698H12.4882C5.96216 182.698 -0.553844 176.751 0.672156 170.881L16.6232 87.9518C18.0552 80.1448 21.9132 76.1348 28.4392 76.1348H66.9002C67.9877 76.1348 69.0574 75.8585 70.009 75.3318C70.9605 74.8051 71.7627 74.0454 72.3402 73.1238L76.2712 66.8538C76.8485 65.932 77.6505 65.172 78.6021 64.6451C79.5536 64.1183 80.6235 63.8418 81.7112 63.8418H169.347C170.899 63.8415 172.436 64.147 173.87 64.7407C175.304 65.3345 176.607 66.2049 177.704 67.3022C178.802 68.3996 179.672 69.7023 180.266 71.1362C180.86 72.57 181.166 74.1068 181.166 75.6588L165.215 170.882C164.234 177.369 159.923 182.698 153.396 182.698Z",
    fill: "white",
    stroke: "#5A5A5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M129.01 119.544H128.065C128.101 119.009 128.145 118.478 128.145 117.932C128.145 111.583 125.622 105.493 121.133 101.004C116.643 96.5139 110.554 93.9915 104.204 93.9912C99.3718 93.9936 94.6535 95.4587 90.6699 98.194C86.6863 100.929 83.624 104.806 81.886 109.315C79.6821 107.129 76.703 105.904 73.599 105.907C70.4705 105.909 67.4707 107.153 65.2591 109.365C63.0474 111.578 61.8051 114.579 61.8051 117.707C61.8085 118.388 61.8711 119.067 61.992 119.737C58.3734 120.282 55.0702 122.106 52.682 124.879C50.2939 127.652 48.9794 131.189 48.9771 134.848C48.9771 138.906 50.589 142.798 53.4583 145.667C56.3276 148.536 60.2192 150.148 64.277 150.148H129.01C133.068 150.148 136.959 148.536 139.829 145.667C142.698 142.798 144.31 138.906 144.31 134.848C144.311 132.839 143.915 130.849 143.147 128.992C142.378 127.135 141.251 125.448 139.83 124.027C138.409 122.606 136.723 121.478 134.866 120.709C133.009 119.94 131.02 119.544 129.01 119.544V119.544Z",
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.627 159.531V125.713",
    stroke: "#6A6A6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.5229 136.735L93.6289 125.714L103.735 136.735",
    stroke: "#6A6A6A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.041 146.951H125.609C127.595 146.951 129.562 146.56 131.397 145.8C133.232 145.04 134.899 143.926 136.303 142.522C137.708 141.118 138.822 139.45 139.582 137.616C140.342 135.781 140.733 133.814 140.733 131.828V131.828C140.733 127.817 139.139 123.971 136.302 121.135C133.466 118.3 129.62 116.707 125.609 116.707H124.676C124.712 116.179 124.755 115.653 124.755 115.117C124.755 108.843 122.262 102.825 117.825 98.3885C113.389 93.9519 107.371 91.4592 101.097 91.459C96.3219 91.4612 91.6593 92.9089 87.7227 95.6116C83.786 98.3144 80.7597 102.145 79.042 106.601C76.8641 104.441 73.9203 103.23 70.853 103.233C67.7618 103.233 64.7972 104.461 62.6113 106.647C60.4254 108.832 59.1973 111.797 59.197 114.888C59.2006 115.561 59.2625 116.233 59.3821 116.895C55.8062 117.433 52.542 119.236 50.1821 121.976C47.8223 124.716 46.5233 128.212 46.521 131.828C46.521 135.838 48.114 139.685 50.9497 142.521C53.7854 145.357 57.6316 146.95 61.6421 146.951H79.213",
    stroke: "#6A6A6A",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_7847"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181.664,
    height: 183.198,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud_upload.a366aae1b94a489de6493ab0dda21df2.svg";
export { ForwardRef as ReactComponent };